// removed by extract-text-webpack-plugin
module.exports = {"container":"container-1ooEi container-1LaSk container-3-GEX input-2t6DG label-Y5lvX","input":"input-2pJ4c","iconContainer":"iconContainer-3pZGy iconContainer-3gJGn","icon":"icon-tQv-T icon-278NI","iconDot":"iconDot-3oGFr iconDot-PheAW","selected":"selected-3b6lK selected-3TCgY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/RadioField/_radioSwitch.css
// module id = 1192
// module chunks = 1